import { render, staticRenderFns } from "./CustomerStoreManage.vue?vue&type=template&id=041570ce&scoped=true"
import script from "./CustomerStoreManage.vue?vue&type=script&lang=js"
export * from "./CustomerStoreManage.vue?vue&type=script&lang=js"
import style0 from "./CustomerStoreManage.vue?vue&type=style&index=0&id=041570ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041570ce",
  null
  
)

export default component.exports